import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'; 
import SignUpPage from './pages/signup'; 
import LoginPage from './pages/login';
import PropertyLeads from './pages/leads';
import Dashboard from './pages/dashboard';
import Subscriptions from './pages/subscriptions';
import ForgotPasswordPage from './pages/forgotPassword'; 
import ResetPasswordPage from './pages/resetPassword';
import Landing from './pages/landing';
import About from './pages/about';
import TermsPage from './pages/terms';
import PrivacyPage from './pages/privacy';

function App() {
  return (
    <BrowserRouter> 
      <Routes>
      <Route path="/" element={<Navigate to="/landing" />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/leads" element={<PropertyLeads />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;